import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PlatformThemeProvider } from '@platform/ui-kit';
import { App } from './App';
/* One shared look for every Project pulldown — see the file for where the values came
   from. Imported once here so a screen only has to add the class. */
import './projectSelect.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Portal failed to mount: #root is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <PlatformThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PlatformThemeProvider>
  </StrictMode>,
);
